<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Supplier Details &nbsp;
          <add-button
            link="/procurement-management/supplier-details/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Supplier Details</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportsupplier_details.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="supplier_details_excel"
                    :fields="excel_fields"
                    worksheet="Supplier Details"
                    name="Supplier Detail.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Supplier Code</th>
                    <th>Name</th>
                    <th>Country</th>
                    <th>Rating</th>
                    <th>Phone</th>
                    <th>Website</th>
                    <th>Email</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="supplier_details.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(supplier_detail, at) in supplier_details"
                    :key="`supplier_detail${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ supplier_detail.supplier_code }}</td>
                    <td>{{ supplier_detail.name }}</td>
                    <td>{{ supplier_detail.country.name }}</td>
                    <td>{{ supplier_detail.rating.name }}</td>
                    <td>{{ supplier_detail.phone }}</td>
                    <td>{{ supplier_detail.website }}</td>
                    <td>{{ supplier_detail.email }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/supplier-details/${supplier_detail.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(supplier_detail.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "supplier_detail",
  data() {
    return {
      supplier_details: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      supplier_details_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        "Supplier Code": "supplier_code",
        Name: "name",
        Country: "country",
        Rating: "rating",
        Phone: "phone",
        Website: "website",
        Email: "email",
      },
      Exportsupplier_details: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let supplier_details = await axios.get(
        `/supplier_details?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.supplier_details = supplier_details.data.data;
      this.count = supplier_details.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let supplier_details = await axios.get(
        `/supplier_details?search=${this.searchData}`
      );
      this.supplier_details = supplier_details.data.data;
      this.count = supplier_details.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Supplier Detail Data";
      this.supplier_details_excel = [];
      let Exportsupplier_details = [];
      Exportsupplier_details = await axios.get(`/supplier_details`);
      this.Exportsupplier_details = Exportsupplier_details.data.data;
      let sr_no = 1;
      this.Exportsupplier_details.forEach((supplier_detail) => {
        this.supplier_details_excel.push({
          sr_no: sr_no,
          supplier_code: supplier_detail.supplier_code
            ? supplier_detail.supplier_code
            : "",
          name: supplier_detail.name ? supplier_detail.name : "",
          country: supplier_detail.country ? supplier_detail.country.name : "",
          rating: supplier_detail.rating ? supplier_detail.rating.name : "",
          phone: supplier_detail.phone ? supplier_detail.phone : "",
          website: supplier_detail.website ? supplier_detail.website : "",
          email: supplier_detail.email ? supplier_detail.email : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=supplier_details`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
